import { LocaleCommon } from '../en/common'

const common: LocaleCommon = {
  addMatches: 'Tambah Perlawanan',
  editMatch: 'Sunting Perlawanan',
  deleteMatch: 'Padam Perlawanan',
  deleteMatchDesc:
    "Are you sure you want to delete this match? Once deleted you can't restore this match again and it will be removed from player profiles and from the club matches page.",
  externalMatchManaged:
    'Perlawanan ini telah dimuat naik pada platform luaran dan mesti diedit atau dipadam di sana.',
  oldPass: 'Kata Laluan Lama',
  newPass: 'Kata Laluan Baru',
  confirmPass: 'Sahkan Kata Laluan',
  save: 'Simpan',
  firstName: 'Nama Pertama',
  lastName: 'Nama Akhir',
  location: 'Lokasi',
  yourBirthday: 'Tarikh Lahir Anda',
  birthday: 'Tarikh Lahir',
  birthDateMin: 'Untuk membuat akaun bagi pengguna di bawah umur 13 tahun, sila lengkapkan borang berikut:',
  under13AccountCreationForm: 'Borang Permohonan Penciptaan Akaun',
  gender: 'Jantina',
  phone: 'Telefon',
  yourPhone: 'Telefon Anda',
  congrats: 'Tahniah!',
  error: 'Ralat',
  search: 'Cari',
  filters: 'Penapis',
  apply: 'Terap',
  clearAll: 'Padam semua',
  distance: 'Jarak',
  noLimit: 'Tiada had',
  man: 'Lelaki',
  woman: 'Perempuan',
  anybody: 'Sesiapa sahaja',
  men: 'Lelaki',
  women: 'Perempuan',
  type: 'Jenis',
  doubles: 'Bergu',
  singles: 'Perseorangan',
  Doubles: 'Bergu',
  Singles: 'Perseorangan',
  Any: 'Mana-mana',
  duprRating: 'Penarafan DUPR',
  ageRange: 'Lingkungan Umur',
  minAge: 'Umur Minimum',
  maxAge: 'Umur Maksimum',
  under19: 'Bawah 19 Tahun',
  share: 'Kongsi',
  message: 'Mesej',
  messages: 'Mesej-mesej',
  email: 'E-mel',
  emailPlaceHolder: 'Masukkan E-mel',
  confirmEmail: 'Sahkan E-mel',
  confirmEmailPlaceHolder: 'Masukkan E-mel Pengesahan',
  password: 'Kata Laluan',
  passwordPlaceHolder: 'Masukkan Kata Laluan',
  confirmPassword: 'Sahkan Kata Laluan',
  confirmPasswordPlaceHolder: 'Masukkan Kata Laluan Pengesahan',
  fullName: 'Nama Penuh',
  fullNamePlaceHolder: 'Masukkan Nama Penuh',
  birthDate: 'Tarikh Lahir',
  birthDatePlaceHolder: 'Pilih Tarikh Lahir',
  phonePlaceHolder: 'Masukkan Telefon',
  continue: 'Teruskan',
  selectCountry: 'Pilih Negara',
  submit: 'Hantar',
  forgotPassword: 'Terlupa Kata Laluan',
  cancel: 'Batal',
  textDigitCode: 'Masukkan Kod 4 Digit Anda',
  resend: 'Hantar Semula',
  verify: 'Sahkan',
  noMoreResults: 'Tiada keputusan lagi.',
  contactSupport: 'Hubungi khidmat sokongan',
  viewAll: 'Lihat Semua',
  payments: 'Pembayaran',
  setUpPayments: 'Tetapkan Pembayaran',
  details: 'Butiran',
  navigate: 'Navigasi',
  member: 'Ahli',
  members: 'Ahli',
  exportCSV: 'Eksport CSV',
  exportFailed: 'Kami tidak dapat mengeksport ahli anda. Sila cuba lagi.',
  exportTimedOut: 'Eksport anda mengambil masa lebih lama daripada jangkaan. Sila cuba lagi sebentar lagi.',
  exportConnectionLost: 'Sambungan terputus semasa menyediakan eksport anda. Sila cuba lagi.',
  downloadCSVDesc: 'Muat turun templat CSV kami untuk mencipta jemputan secara pukal menggunakan emel.',
  downloadCSVNote: 'NOTA: Anda perlu membuang pemisah di atas fail CSV',
  learnMore: 'Ketahui Lebih Lanjut',
  downloadTemplate: 'Muat Turun Templat',
  dragFile: 'Seret fail CSV anda di sini atau',
  browseFile: 'Lihat Fail',
  removeFile: 'Padam fail',
  matches: 'Perlawanan',
  match: 'Perlawanan',
  sort: 'Urut',
  newToOld: 'Baharu ke Lama',
  oldToNew: 'Lama ke Baharu',
  clearFilters: 'Padam Penapis',
  matchId: 'ID Perlawanan:',
  reUpload: 'Muat Naik Semula',
  events: 'Acara',
  deleteEvent: 'Padam Acara',
  deleteEventDesc: 'Menyemak acara ini juga akan memadamkan bracket yang berkaitan. Sahkan untuk memadam acara ini.',
  confirm: 'Sahkan',
  delete: 'Padam',
  registeredPlayers: 'Pemain Berdaftar',
  upcoming: 'Akan Datang',
  draft: 'Draf',
  open: 'dibuka',
  ongoing: 'Sedang Berlangsung',
  completed: 'Selesai',
  logo: 'Logo',
  eventLogo: 'Logo Acara',
  eventName: 'Nama Acara',
  registration_url: 'URL Pendaftaran',
  summary: 'Ringkasan',
  whatAreTheDetails: 'Apakah butiran tersebut?',
  entryFee: 'Bayaran Penyertaan',
  entryFeeDesc:
    'Pemain akan membayar bayaran masuk ini di atas yuran bracket mereka. Anda boleh menetapkan harga yuran setiap bracket kemudian.',
  memberPrice: 'Harga Ahli',
  nonMemberPrice: 'Harga Bukan Ahli',
  policies: 'Polisi',
  uploadWaiver: 'Muat Naik Penepian',
  uploadWaiverDesc: 'DUPR menggalakkan acara untuk memasukkan penepian liabiliti.',
  liabilityWaiver: 'Penepian Liabiliti',
  refundPolicy: 'Polisi Pembayaran Balik',
  refundPolicyDesc:
    'Adakah pendaftar akan menerima bayaran balik penuh atau sebahagian jika mereka membatalkan sebelum acara bermula? Adakah mereka akan menerima bayaran balik sebahagian jika mereka membatalkan selepas liga dimulakan?',
  healthPolicy: 'Polisi Kesihatan',
  healthPolicyDesc: 'Adakah liga anda mempunyai peraturan tertentu mengenai kesihatan dan keselamatan peserta?',
  bracket: 'Bracket',
  brackets: 'Bracket',
  addBracket: 'Tambah Bracket',
  select: 'Pilih',
  playerGroup: 'Kumpulan Pemain',
  format: 'Format',
  ratingRange: 'Julat Penarafan',
  minimum: 'Minimum',
  maximum: 'Maksimum',
  name: 'Nama',
  bracketName: 'Nama Bracket',
  autoGenerate: 'Hasil Automatik',
  courts: 'Gelanggang',
  courtsDesc: 'Bilangan Gelanggang (Minimum 1 dan Maksimum 8)',
  maxTeams: 'Pasukan Maksimum',
  maxTeamsDec: 'Berapa banyak pasukan yang akan menyertai acara ini?',
  waitList: 'Senarai Menunggu',
  waitListDesc: 'Berapa banyak pasukan yang anda ingin benarkan untuk menyertai senarai menunggu?',
  registration: 'Pendaftaran',
  registrationDesc: 'Tetapkan tempoh yang pemain boleh mendaftar',
  startDateTime: 'Tarikh & Masa Mula',
  endDateTime: 'Tarikh & Masa Tamat',
  competition: 'Pertandingan',
  competitionDesc: 'Tetapkan tarikh dan masa untuk pertarungan bracket ini',
  timeZone: 'Zon Masa',
  price: 'Harga',
  priceDesc: 'Pemain akan membayar ini serta bayaran masuk',
  selectAnImage: 'Pilih gambar untuk dimuat naik',
  loadingImage: 'Memuat gambar...',
  chooseFile: 'Pilih Fail',
  invite: 'Jemput',
  optional: '(Pilihan)',
  messageAndDataRatesMayApply: 'Kadar mesej dan data mungkin dikenakan.',
  sendInvite: 'Hantar Jemputan',
  invites: 'Jemputan',
  requests: 'Permintaan',
  invited: 'Dijemput',
  ignoreAll: 'Abaikan Semua',
  acceptAll: 'Terima Semua',
  ignore: 'Abaikan',
  cancelInvite: 'Batalkan Jemputan',
  address: 'Alamat',
  addNew: 'Tambah Baru',
  mi: 'Mi',
  startsIn: 'Bermula dalam',
  endsIn: 'Tamat dalam',
  downloadLiabilityWaiver: 'Muat Turun Penepian Tanggungjawab',
  healthSafetyPolicy: 'Polisi Kesihatan & Keselamatan',
  yes: 'Ya',
  no: 'Tidak',
  addPartner: 'Tambah Rakan Bergu',
  addPartnerNote: 'Anda juga boleh tunggu sehingga selepas pendaftaran untuk menambah rakan',
  ok: 'OK',
  success: 'Berjaya',
  failure: 'Gagal',
  signUpOrLogin: 'Daftar atau Log Masuk untuk melihat maklumat ini',
  accept: 'Terima',
  goBack: 'Kembali',
  with: 'dengan',
  game: 'Permainan',
  highToLowRating: 'Tinggi ke Rendah Penarafan',
  lowToHighRating: 'Rendah ke Tinggi Penarafan',
  add: 'Tambah',
  confirmation: 'Pengesahan',
  back: 'Kembali',
  next: 'Seterusnya',
  saveChanges: 'Simpan Perubahan',
  sortingRules: 'Peraturan Pengurutan',
  sortingRulesDesc:
    'Pasukan diurutkan mengikut penarafan purata. Penarafan yang disahkan lebih diberi perhatian berbanding penarafan provisional. Pemain dengan penarafan NR dianggap mempunyai penarafan 2.00.',
  create: 'Cipta',
  matchDate: 'Tarikh Perlawanan',
  time: 'Masa',
  connectWith: 'Sambung Dengan',
  externalApplication: 'Pangkat paling tepat dalam pickleball',
  externalLoginCheckbox:
    'Benarkan DUPR untuk membuat sesi baru untuk laman ini menggunakan akses hanya bacaan, semua data saya akan dilindungi dan selamat',
  logging: 'Sedang Log Masuk...',
  login: 'Log Masuk',
  saveMatch: 'Simpan Perlawanan',
  submitMatches: 'Hantar Perlawanan',
  confirmSubmitMatches: 'Perlawanan ini akan dihantar dan penarafan pemain akan dikemas kini sebentar lagi.',
  event: 'Acara',
  eventPlaceHolder: 'Nama Acara',
  date: 'Tarikh',
  checkboxAddYourSelf: 'Tambah diri anda sebagai pemain dalam perlawanan ini?',
  team1: 'Pasukan 1',
  team2: 'Pasukan 2',
  searchPlayer: 'Cari Pemain',
  score: 'Markah',
  standard: 'Standard',
  rally: 'Berbalas pukulan',
  game1: 'Permainan 1',
  game2: 'Permainan 2',
  game3: 'Permainan 3',
  game4: 'Permainan 4',
  game5: 'Permainan 5',
  addAnotherMatch: 'Tambah Perlawanan Lain',
  oops: 'Alamak!',
  venturedPath: 'Anda telah melangkah dari laluan.',
  redirectedDashboard: 'Anda akan diarahkan ke Papan Pemuka dalam',
  seconds: 'detik',
  DUPRIDCopied: 'DUPRID Disalin!',
  copyClipboard: 'Salin ke papan keratan',
  myAccount: 'Akaun Saya',
  editProfile: 'Sunting Profil',
  passwordSecurity: 'Kata Laluan dan Keselamatan',
  infoSupport: 'Info dan Sokongan',
  support: 'Sokongan',
  runEvents: 'Jalankan Acara',
  FAQs: 'Soalan Lazim',
  termsUse: 'Terma Penggunaan',
  privacyPolicy: 'Polisi Privasi',
  logout: 'Log Keluar',
  warning: 'AMARAN',
  reset: 'Tetapkan Semula',
  Members: 'Ahli',
  Matches: 'Perlawanan',
  Events: 'Acara',
  Invites: 'Jemputan',
  Queue: 'Barisan',
  Standings: 'Jadual',
  Players: 'Pemain',
  Teams: 'Pasukan',
  UnmatchedPlayer: 'Pemain Tidak Seimbang',
  Payments: 'Pembayaran',
  performance: 'Prestasi',
  myPerformance: 'Prestasi Saya',
  newMatch: 'Perlawanan Baru',
  players: 'Pemain',
  clubs: 'Kelab',
  Week: 'Minggu',
  Month: 'Bulan',
  RoundRobin: 'Pusingan Robin',
  Waterfall: 'Air Terjun',
  FlexLeague: 'Liga Fleksibel',
  Mixed: 'Campuran',
  Open: 'Terbuka',
  Men: 'Lelaki',
  Women: 'Perempuan',
  ViewAll: 'Lihat Semua',
  Round: 'Pusingan',
  Round1: 'Pusingan 1',
  Round2: 'Pusingan 2',
  Round3: 'Pusingan 3',
  Round4: 'Pusingan 4',
  Round5: 'Pusingan 5',
  Round6: 'Pusingan 6',
  Round7: 'Pusingan 7',
  Round8: 'Pusingan 8',
  Round9: 'Pusingan 9',
  Round10: 'Pusingan 10',
  Dashboard: 'Papan Pemuka',
  SearchPlayer: 'Cari Pemain',
  SearchEvents: 'Cari Acara',
  Rankings: 'Kedudukan',
  Genie: 'Genie',
  Shops: 'Kedai',
  HowItWorks: 'Bagaimana Ia Berfungsi',
  RunEvents: 'Jalankan Acara',
  CollegiatePickleball: 'Pickleball Kuliah',
  News: 'Berita',
  LogIn: 'Log Masuk',
  SignUp: 'Daftar',
  decline: 'Tolak',
  savePublish: 'Simpan & Terbit',
  publish: 'Terbit',
  publishing: 'Menerbitkan',
  upload: 'Muat Naik',
  signUpLogin: 'Daftar atau Masuk',
  January: 'Januari',
  February: 'Februari',
  March: 'Mac',
  April: 'April',
  May: 'Mei',
  June: 'Jun',
  July: 'Julai',
  August: 'Ogos',
  September: 'September',
  October: 'Oktober',
  November: 'November',
  December: 'Disember',
  following: 'Mengikuti',
  followers: 'Pengikut',
  rating: 'Penarafan',
  MatchDate: 'Tarikh Perlawanan',
  CreatedDate: 'Tarikh Dicipta',
  ModifiedDate: 'Tarikh Diubah',
  follow: 'Ikut',
  unFollow: 'Berhenti Ikut',
  noFollowing: 'Pemain ini tidak mengikuti sesiapa pun lagi',
  noFollower: 'Pemain ini tidak mempunyai sebarang pengikut lagi',
  notFollowing: 'Pemain ini tidak mengikuti sesiapa pun',
  home: 'Rumah',
  removeConfirm: 'Adakah anda pasti anda ingin membuang ini?',
  edit: 'Sunting',
  play: 'Main',
  invitePlayerSuccess: 'Tambah ahli berjaya',
  createAMatch: 'Cipta Sebuah Perlawanan',
  marketingAssets: 'Sumber Kelab',
  settings: 'Tetapan',
  compliantText:
    'Dengan menandakan kotak ini anda bersetuju bahawa anda ingin menerima maklumat lebih lanjut mengenai kemas kini produk, acara, berita dan tawaran kami',
  communityGuidelines: 'Garis Panduan Komuniti',
  minorLeaguePickleball: 'Liga Minor',
  collegiatePickleball: 'Pickleball Kuliah',
  blog: 'Blog',
  playerName: 'Nama Pemain',
  addMembers: 'Tambah Ahli Kumpulan',
  verifyEmail: 'Sahkan E-mel anda',
  mustVerify: 'Anda mesti mengesahkan e-mel anda untuk mengakses ciri ini.',
  clickResendLink: 'Klik "hantar semula pautan" untuk menerima pautan pengesahan.',
  changeEmail: 'Adakah anda ingin menukar e-mel anda?',
  alreadyVerified: 'Telah Disahkan',
  resendLink: 'Hantar Semula Pautan',
  aLinkWasSent: 'Pautan telah dihantar ke e-mel baharu anda!',
  matchOwner: 'Pemilik Perlawanan',
  hasVerifiedMatch: 'Pemain telah mengesahkan perlawanan',
  firstNamePlaceHolder: 'Masukkan Nama Pertama',
  lastNamePlaceHolder: 'Masukkan Nama Akhir',
  removed: 'Dibuang',
  today: 'Hari ini',
  yesterday: 'Semalam',
  privacy: 'Privasi',
  displayAge: 'Paparkan Umur',
  hideAge: 'Sembunyi Umur',
  displayLocation: 'Paparkan Lokasi',
  hideLocation: 'Sembunyikan Lokasi',
  doNotTrack: 'Jangan Jejak',
  allowTracking: 'Benarkan Jejakan',
  allowTargetedAds: 'Benarkan Iklan Berdasarkan Sasaran',
  disallowTargetedAds: 'Tolak Iklan Berdasarkan Sasaran',
  subscriptions: 'Langganan',
  haveActiveSubscription: 'Anda mempunyai langganan aktif.',
  toManageSubscription: 'Sila urus langganan anda, terima kasih',
  visitThisLinkTo: 'Lawati pautan ini untuk',
  subscriptionStatus: 'Trạng thái đăng ký',
  manageSubscription: 'Mengurus Langganan',
  and: 'dan',
  phoneVerify:
    'Dengan memasukkan nombor telefon bimbit saya, saya bersetuju untuk menerima mesej teks untuk pengesahan akaun dan pengesahan dua faktor (2FA). Kadar mesej dan data standard mungkin dikenakan. Mesej ini digunakan semata-mata untuk membantu melindungi akaun saya dan mengesahkan identiti saya dan bukan untuk pemasaran',
  phoneOptInRequired:
    'Anda mesti bersetuju dengan pilihan ikut serta mesej teks untuk pengesahan akaun dan pengesahan dua faktor di atas.',

  verifyYourPhone: 'Sahkan nombor telefon anda',
  sentCodeTo: 'Kami telah menghantar kod ke {{phone}}',
  sendCodeTo: 'Hantar kod ke {{phone}}',
  phoneVerified: 'Nombor telefon disahkan',
  youreAllSet: 'Anda sudah bersedia.',
  sending: 'Menghantar...',
  sendCode: 'Hantar kod',
  verifying: 'Mengesahkan...',
  resendIn: 'Hantar semula dalam {{s}} saat',
  resendCode: 'Hantar semula kod',
  otpDisclaimer: 'Kos mesej standard mungkin dikenakan.',
  invalidCode: 'Kod tidak sah, sila cuba lagi.',
  genericError: 'Ada yang tidak kena. Sila cuba lagi.',
  phoneMissing: 'Tiada nombor telefon untuk disahkan.',
  verifyingNumber: 'Mengesahkan nombor',
  iso: 'ISO',
  changeNumber: 'Tukar nombor',
}

export default common
